/*
  Project: House to Home
  Author: SOS Media Corp
 */
import $ from 'jquery';
import slickInit from './modules/slickSlider';

$(document).ready(() => {

	slickInit();

	// Social share
	$('.share-me').on("click", function(e){
	  e.preventDefault();
	  var share_url = $(this).attr('href'),
	      win_title = $(this).attr('data-share-title'),
	      win_w = 500,
	      win_h = 500;

	  // open pop up window
	  var shareWindow = window.open(share_url,win_title,'width=' + win_w + ',' + 'height=' + win_h);
	  shareWindow.focus();
	});

	// Listing Form Population
	$(document).on( 'nfFormReady', function() {
		if ($('input.listing-name').length > 0) {
			var listing = $('.inquiry').attr('data-listing');
			$('input.listing-name').val(listing).trigger('change');
		}
	});
	


	// Menu functions
	 $('.js-main-menu').on('click', function() {
	   $(this).toggleClass('menu-open');
	   $('.nav-collapsed').toggleClass('is-open');

	   if ($(this).hasClass('menu-open')) {
	   	$('.label').html('Close');
	   } else {
	   	$('.label').html('Menu');
	   }

	 });

	 // Drop-down menu
	 $('.menu-item-has-children > a').on('click', function(e) {
	 	e.preventDefault();
	   var section = $(this).parent();
	   section.toggleClass('drop-open');
	   section.find('ul').slideToggle();
	 });

	 // ACF Accordion
	 $(document).on('click', '.block-accordion .section-header', function() {
	 	var _this = $(this);
	 	_this.next('.entry-content').slideToggle();
	 	_this.toggleClass('acc-open');
	 })

	 // Switch menu on scroll
	 $(window).scroll(function() {
	 	var top = $(document).scrollTop();
	 	
	 	if ((top >= 80) && (top < 400) && (!$('.site-header').hasClass('hide-nav'))) {
	 		$('.site-header').addClass('hide-nav');
	 	} else if ((top >= 400) && (!$('.site-header').hasClass('scroll'))) {
	 		$('.site-header').addClass('scroll');
	 	} else if (top < 80) {
	 		$('.site-header').removeClass('scroll').removeClass('hide-nav');
	 	}
	 });

	// Smooth scroll for ID links
	 $('a[href^="#"]').each( function() {
	     var $this = $(this), 
	         target = this.hash;
	     $(this).click(function (e) { 
	         e.preventDefault();
	         if( $this.length > 0 ) {
	             if($this.attr('href') == '#' ) {
	                 // Do nothing   
	             } else {
	             	if ($(target).length) {
	             		$('html, body').animate({ 
	             		     scrollTop: ($(target).offset().top) - 60 
	             		 }, 1000);
	             	} else {
	             		var target_class = target.split('#');
	             		target = '.' + target_class[1];
	             		if ($(target).length) {
	             			$('html, body').animate({ 
	             			     scrollTop: ($(target).offset().top) - 60 
	             			 }, 1000);
	             		}
	             	}
	                
	             }  
	         }
	     });
	 });  

 });


// WEBPACK FOOTER //
// ./wp/wp-content/themes/house-to-home-equity-corp-chisel/src/scripts/app.js